import React from "react";
import { Brand_Timeline, useTimelinePages } from "@doitforme/brand-timeline";
import { get_brand_timeline_page, watch_brand_timeline } from "../../../../services/api/Prospects";

export default function Brands_Timeline(props) {
    const brand = props.activeBrandRow || {};
    const brandId = brand.brandId || brand._id;
    const page = useTimelinePages({
        identity: brandId ? [brand.prospectId, brandId].join(":") : "",
        refreshKey: brand.updatedAt || props.refreshKey, t: props.t,
        readPage: cursor => get_brand_timeline_page(brand.prospectId, brandId, cursor || null),
        readChanges: (revision, signal) => watch_brand_timeline(brand.prospectId, brandId, revision, signal)
    });
    return (
        <section>
            <Brand_Timeline {...page} t={props.t}
                onLoadMore={page.load_more} onRetry={page.retry} onRefresh={page.refresh}></Brand_Timeline>
        </section>
    );
}
export { Brands_Timeline };
